import HttpRequest from "@/store/axios";
import config from "@/config/config";
import { setSession, removeSession } from "@/store/funcs";

const apiSso = new HttpRequest(
	process.env.NODE_ENV === "development"
		? config.apiUrl.dev
		: config.apiUrl.pro
);

export default {
	mutations: {},
	getters: {},
	actions: {
		//getToken
		getToken({ commit }, data) {
			return new Promise((resolve, reject) => {
				apiSso
					.apiRequest(data, "index-getToken.html", "post")
					.then((res) => {
						if (res.code == 1) {
							let tmpData = JSON.parse(res.data);
							setSession("token", tmpData.token);
							setSession("siteConfig", tmpData.rows.siteConfig);
							setSession("siteMenu", tmpData.rows.menu);
							setSession("agreement", tmpData.rows.agreement);
						}
						resolve(res);
					})
					.catch((err) => {
						reject(err);
					});
			});
		},
		// 接受协议
		agreeAgreement({ commit }, { obj }) {
			return new Promise((resolve, reject) => {
				setSession("checkAgreeFlag", true);
				resolve();
			});
		},
		//不接受协议
		disagreeAgreement({ commit }) {
			removeSession("checkAgreeFlag");
		},
	},
};
